import {http} from '../util/http'
import {API_KOTLIN_DOMAIN} from '../config'
import headers from './employeeSystemHeader'
import axios from "axios"

export const getClubComplaintList = (queryParams) => {
    return http({
        headers: headers(),
        url: `${API_KOTLIN_DOMAIN}/business-club/complaint/club/list`,
        params: {
            ...queryParams
        }
    })
}

export const getComplaintDetail = (serialNumber) => {
    return http({
        headers: headers(),
        url: `${API_KOTLIN_DOMAIN}/business-club/complaint/detail`,
        params: {
            serialNumber
        }
    })
}

export const clubComplaintHandle = (data) => {
    return http({
        headers: headers(),
        url: `${API_KOTLIN_DOMAIN}/business-club/complaint/club/handle`,
        data: data,
        method: 'post'
    })
}

export const clubComplaintAddProof = (data) => {
    return http({
        headers: headers(),
        url: `${API_KOTLIN_DOMAIN}/business-club/complaint/club/addProof`,
        data: data,
        method: 'post'
    })
}

export const checkClubUpload = (urls, clubId) => {
    return http({
        headers: headers(),
        url: `${API_KOTLIN_DOMAIN}/business-club/complaint/club/upload`,
        params: {
            urls,
            clubId
        }
    })
}

// 图片上传至七牛
export const uploadImageToQiNiu = (qiNiuToken, filePath) => {
    const formData = new FormData()
    formData.append('token', qiNiuToken)
    formData.append('file', filePath)
    return axios({
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        url: 'https://up.qiniup.com',
        method: 'post',
        data: formData,
    })
}



// WEBPACK FOOTER //
// ./src/api/complaintManager.js